window.addEventListener('flickity:ready', function() {
  if (document.querySelector('[data-image-index]')) {
      let carousel = document.querySelector('flickity-carousel');
      let flkty = window.ThemeFlickity(carousel, JSON.parse(carousel.getAttribute('flickity-config')));
      let selectedIndex = Number(document.querySelector('[data-image-index]').dataset.imageIndex) - 1;
      let customizerInputs = document.querySelectorAll('[personalise]');
      let customizerResets = document.querySelectorAll('[reset-personalize]');
      let badgeSelector = document.querySelector('#badges-combo-box select');
      let sponsorSelector = document.querySelector('#sponsors-combo-box select');
      let form = document.querySelector('#form-name-name').form;
      let initImage = document.querySelector('[data-image-index]').dataset.initImage;

      if (initImage == 'true') {
        customizerInputs.forEach(input => {
          if (input?.value && input.value != '') {
            console.log('input', input.value);
            initChangeFlickityIndexToCustomizerPicture(input);
          }
        });
      }

      form.addEventListener("variant:changed", () => {
        checkInputValidity();
      });

      for (let input of customizerInputs) {
          input.addEventListener('input', function(e) {
            let name_elements = '#form-name-name, #form-name-id, #form-name-quantity, #form-name-line-id, #form-name-returnable';

            if (e.target.value == 'None') {
              //document.querySelectorAll(name_elements).forEach(e => { e.disabled = true; });
              resetCustomizerLayer(e);
            } else {
              //document.querySelectorAll(name_elements).forEach(e => { e.disabled = false; });
              changeFlickityIndexToCustomizerPicture(e);
            }
            
            checkInputValidity();
          });
        
          input.addEventListener('click', function(e) {
            if (e.target.value == 'None') {
              //document.querySelectorAll(name_elements).forEach(e => { e.disabled = true; });
              resetCustomizerLayer();
            } else {  
              //document.querySelectorAll(name_elements).forEach(e => { e.disabled = false; });
              changeFlickityIndexToCustomizerPicture(e);
            }
            
            checkInputValidity();
          });
      }
    
      for (let input of customizerResets) {
          input.addEventListener('click', function(e) { resetCustomizerLayer(); checkInputValidity(); });
      }

      if (badgeSelector) {
        badgeSelector.addEventListener('change', function(e) {
          /*changeFlickityIndexToCustomizerPicture(e);*/

          let select = this;
          let selectedOption = select[select.selectedIndex];

          if (select.selectedIndex > 0) {
            toggleBadgeLayer();

            /* Customizer preview */
            /*changeBadgeRenderOutput(
                  document.querySelector('#customizer-badge'),
                  document.querySelector('.product-badges').dataset.width,
                  document.querySelector('.product-badges').dataset.height,
                  document.querySelector('.product-badges').dataset.x,
                  document.querySelector('.product-badges').dataset.y,
                  document.querySelector('#badges-data [data-id="' + selectedOption.dataset.id + '"]').dataset.src,
                  document.querySelector('#badges-data [data-id="' + selectedOption.dataset.id + '"]').dataset.alt
              );*/

            /* Badge preview */
            changeBadgeRenderOutput(
              document.querySelector('.select-badge-preview'),
              null,
              null,
              null,
              null,
              document.querySelector('#badges-data [data-id="' + selectedOption.dataset.id + '"]').dataset.src,
              document.querySelector('#badges-data [data-id="' + selectedOption.dataset.id + '"]').dataset.alt
            );

            if (document.querySelector('.select-with-badge-preview button')) {
              document.querySelector('.select-with-badge-preview button').classList.remove('full-width');
            }

            let badge_elements = '#form-badge-id, #form-badge-name, #form-badge-quantity, #form-badge-line-id, #form-badge-returnable';

            if (Number(selectedOption.dataset.id) === 0) {
              document.querySelectorAll(badge_elements).forEach(e => { e.disabled = true; });
              document.querySelectorAll('[customizer-badge-prop]').forEach(t => { t.disabled = true; });
            } else {
              document.querySelectorAll(badge_elements).forEach(e => { e.disabled = false; });
              document.querySelectorAll('[customizer-badge-prop]').forEach(t => { t.disabled = false; });
            }

            document.querySelector('#form-badge-id').value = Number(selectedOption.dataset.id);
            document.querySelector('#form-badge-name').value = selectedOption.value.replace(/\s*\(\+[^)]+\)$/, '');
            document.querySelector('#form-badge-line-id').value = Number(selectedOption.dataset.id);

            updateCustomizerProportions();
          } else {
            toggleBadgeLayer(true);
            if (document.querySelector('.select-with-badge-preview button')) {
              document.querySelector('.select-with-badge-preview button').classList.add('full-width');
            }

            let badge_elements = '#form-badge-id, #form-badge-name, #form-badge-quantity, #form-badge-line-id, #form-badge-returnable';
            document.querySelectorAll(badge_elements).forEach(e => { e.disabled = true; });
            document.querySelectorAll('[customizer-badge-prop]').forEach(t => { t.disabled = true; });

          }

          updateCustomizerReturnable();
        });
      }
    
      if (sponsorSelector) {
        sponsorSelector.addEventListener('change', function(e) {
          /*changeFlickityIndexToCustomizerPicture(e);*/

          let select = this;
          let selectedOption = select[select.selectedIndex];

          if (select.selectedIndex > 0) {
            toggleSponsorLayer();

            /* Customizer preview */
            /*changeBadgeRenderOutput(
                  document.querySelector('#customizer-badge'),
                  document.querySelector('.product-badges').dataset.width,
                  document.querySelector('.product-badges').dataset.height,
                  document.querySelector('.product-badges').dataset.x,
                  document.querySelector('.product-badges').dataset.y,
                  document.querySelector('#badges-data [data-id="' + selectedOption.dataset.id + '"]').dataset.src,
                  document.querySelector('#badges-data [data-id="' + selectedOption.dataset.id + '"]').dataset.alt
              );*/

            /* Badge preview */

            if (document.querySelector('.select-sponsors-preview')) {
              changeSponsorsRenderOutput(
                document.querySelector('.select-sponsors-preview'),
                null,
                null,
                null,
                null,
                document.querySelector('#sponsors-data [data-id="' + selectedOption.dataset.id + '"]').dataset.src,
                document.querySelector('#sponsors-data [data-id="' + selectedOption.dataset.id + '"]').dataset.alt
              )

              document.querySelector('.select-with-sponsors-preview button').classList.remove('full-width')
            }

            let sponsor_elements = '#form-sponsor-id, #form-sponsor-name, #form-sponsor-quantity, #form-sponsor-line-id, #form-sponsor-returnable';

            if (Number(selectedOption.dataset.id) === 0) {
              document.querySelectorAll(sponsor_elements).forEach(e => { e.disabled = true; });
              document.querySelectorAll('[customizer-sponsor-prop]').forEach(t => { t.disabled = true; });
            } else {
              document.querySelectorAll(sponsor_elements).forEach(e => { e.disabled = false; });
              document.querySelectorAll('[customizer-sponsor-prop]').forEach(t => { t.disabled = false; });
            }

            document.querySelector('#form-sponsor-id').value = Number(selectedOption.dataset.id);
            document.querySelector('#form-sponsor-name').value = selectedOption.value.replace(/\s*\(\+[^)]+\)$/, '');
            document.querySelector('#form-sponsor-line-id').value = Number(selectedOption.dataset.id);

            updateCustomizerProportions();
          } else {
            toggleSponsorLayer(true);
            document.querySelector('.select-with-sponsors-preview button').classList.add('full-width');

            let sponsor_elements = '#form-sponsor-id, #form-sponsor-name, #form-sponsor-quantity, #form-sponsor-line-id, #form-sponsor-returnable';
            document.querySelectorAll(sponsor_elements).forEach(e => { e.disabled = true; });
            document.querySelectorAll('[customizer-sponsor-prop]').forEach(t => { t.disabled = true; });

          }

          updateCustomizerReturnable();
        });
      }

      function checkPersonaliseNameForBadWords() {
          const nameInput = document.querySelector('#product-personalise__name');
          if (!nameInput || !window.PersonaliseBadWords) return true;
          return window.PersonaliseBadWords.validateNameInput(nameInput);
      }

      function checkInputValidity() {
          let selectedTab = document.querySelector('.personalise-product-personalise__tab-buttons .button--primary');
          let submitButton = document.querySelector('#AddToCart');
          let name_elements = '#form-name-name, #form-name-number, #form-name-id, #form-name-quantity, #form-name-line-id, #form-name-returnable';
          let mandatoryFields = document.querySelectorAll('#form-name-name, #form-name-number');
          let wrongFields = 0;
          let allowToSubmit = true;
          const nameIsClean = checkPersonaliseNameForBadWords();
          
          console.log('checkInputValidity => ', Number(selectedTab.dataset.id))
          switch(Number(selectedTab.dataset.id)) {
              case -1:
                document.querySelectorAll(name_elements).forEach(e => { e.disabled = true; });
                document.querySelectorAll('[customizer-prop]').forEach(t => { t.disabled = true; });
                break;
              case 0:
                document.querySelectorAll(name_elements).forEach(e => { e.disabled = false; });
                document.querySelectorAll('[customizer-prop]').forEach(t => { t.disabled = false; });
                mandatoryFields.forEach(e => {
                  if (e.value === '' || e.value === 'None' || e.value === 'undefined') {
                     wrongFields++;
                  } 
                });
            
                if (wrongFields >= 2) {
                  allowToSubmit = false;
                  document.querySelectorAll(name_elements).forEach(e => { e.disabled = true; });
                  document.querySelectorAll('[customizer-prop]').forEach(t => { t.disabled = true; });
                } 
                break;
              case 1:
                document.querySelectorAll(name_elements).forEach(e => { e.disabled = false; });
                document.querySelectorAll('[customizer-prop]').forEach(t => { t.disabled = false; });

                mandatoryFields.forEach(e => {
                    if (e.value === '' || e.value === 'None' || e.value === 'undefined') {
                       wrongFields++;
                    } 
                  });
              
                  if (wrongFields >= 2) {
                    allowToSubmit = false;
                    document.querySelectorAll(name_elements).forEach(e => { e.disabled = true; });
                    document.querySelectorAll('[customizer-prop]').forEach(t => { t.disabled = true; });
                  }
                break;
          }

          if (!nameIsClean) {
              allowToSubmit = false;
          }
          
          if (!allowToSubmit) {
              submitButton.disabled = true;
          } else {
              submitButton.disabled = false;
          }

          updateCustomizerReturnable();
      }

      function initChangeFlickityIndexToCustomizerPicture(e) {
        if (!isNaN(selectedIndex)) {
            if (flkty.selectedIndex !== selectedIndex) {
                flkty.selectCell(selectedIndex);
                document.querySelector('#customizer-layer').classList.remove('invisible');
            }
        }

        if (e.id === 'product-personalise__name') {
            changeTextRenderOutput(
                document.querySelector('#customizer-text'),
                document.querySelector('.product-personalise').dataset.textFont,
                document.querySelector('.product-personalise').dataset.textSize,
                document.querySelector('.product-personalise').dataset.textColor,
                document.querySelector('.product-personalise').dataset.textWeight,
                document.querySelector('.product-personalise').dataset.textStyle,
                document.querySelector('.product-personalise').dataset.textX,
                document.querySelector('.product-personalise').dataset.textY,
                (document.querySelector('#customizer-text').getAttribute('predefined-svg-font') !== null ? e.value.toUpperCase() : capitalize(e.value))
            );
        } else if (e.id === 'product-personalise__number') {
            changeNumberRenderOutput(
                document.querySelector('#customizer-number'),
                document.querySelector('.product-personalise').dataset.numberFont,
                document.querySelector('.product-personalise').dataset.numberSize,
                document.querySelector('.product-personalise').dataset.textColor,
                document.querySelector('.product-personalise').dataset.numberWeight,
                document.querySelector('.product-personalise').dataset.numberStyle,
                document.querySelector('.product-personalise').dataset.numberX,
                document.querySelector('.product-personalise').dataset.numberY,
                e.value
            );
        }

        updateCustomizerProportions();
      }

      function changeFlickityIndexToCustomizerPicture(e) {
          if (!isNaN(selectedIndex)) {
              if (flkty.selectedIndex !== selectedIndex) {
                  flkty.selectCell(selectedIndex);
                  document.querySelector('#customizer-layer').classList.remove('invisible');
              }
          }

          if (e.target.id === 'product-personalise__name') {
              changeTextRenderOutput(
                  document.querySelector('#customizer-text'),
                  document.querySelector('.product-personalise').dataset.textFont,
                  document.querySelector('.product-personalise').dataset.textSize,
                  document.querySelector('.product-personalise').dataset.textColor,
                  document.querySelector('.product-personalise').dataset.textWeight,
                  document.querySelector('.product-personalise').dataset.textStyle,
                  document.querySelector('.product-personalise').dataset.textX,
                  document.querySelector('.product-personalise').dataset.textY,
                  (document.querySelector('#customizer-text').getAttribute('predefined-svg-font') !== null ? e.target.value.toUpperCase() : capitalize(e.target.value))
              );
          } else if (e.target.id === 'product-personalise__number') {
              changeNumberRenderOutput(
                  document.querySelector('#customizer-number'),
                  document.querySelector('.product-personalise').dataset.numberFont,
                  document.querySelector('.product-personalise').dataset.numberSize,
                  document.querySelector('.product-personalise').dataset.textColor,
                  document.querySelector('.product-personalise').dataset.numberWeight,
                  document.querySelector('.product-personalise').dataset.numberStyle,
                  document.querySelector('.product-personalise').dataset.numberX,
                  document.querySelector('.product-personalise').dataset.numberY,
                  e.target.value
              );
          }

          updateCustomizerProportions();
      }
    
      function resetCustomizerLayer() {
          console.log('resetCustomizerLayer')
          
          document.querySelector('#customizer-text').innerText = '';
          document.querySelector('#customizer-number').innerText = '';
          
          if (document.querySelector('#customizer-badge'))
              document.querySelector('#customizer-badge').innerHTML = '';
        
          let name_elements = '#product-personalise__name, #product-personalise__number';
          document.querySelectorAll(name_elements).forEach(e => {
            e.value = '';
            e.classList.remove('is-invalid');
            e.removeAttribute('aria-invalid');
            e.dispatchEvent(new CustomEvent('input'));
          });
      }

      function capitalize(s) {
          return s.toLowerCase().charAt(0).toUpperCase() + s.toLowerCase().slice(1);
      }

      function toggleCustomizerLayer(hide = false) {
          if (hide)
              document.querySelector('#customizer-layer').classList.add('invisible');
          else
              document.querySelector('#customizer-layer').classList.remove('invisible');
      }

      function toggleBadgeLayer(hide = false) {
          if (hide) {
              /*document.querySelector('#customizer-badge').classList.add('invisible');*/
              if (document.querySelector('.select-badge-preview')) {
                document.querySelector('.select-badge-preview').classList.add('invisible');
              }
          } else {
              /*document.querySelector('#customizer-badge').classList.remove('invisible');*/
              if (document.querySelector('.select-badge-preview')) {
                document.querySelector('.select-badge-preview').classList.remove('invisible');
              }
          }
      }

      function toggleSponsorLayer(hide = false) {
        if (hide) {
            if (document.querySelector('.select-sponsors-preview')) {
              document.querySelector('.select-sponsors-preview').classList.add('invisible')
            }
        } else {
            if (document.querySelector('.select-sponsors-preview')) {
              document.querySelector('.select-sponsors-preview').classList.remove('invisible')
            }
        }
      }

      function changeBadgeRenderOutput(layer, width, height, x, y, imgSrc, imgAlt) {
        if (layer) {
          layer.setAttribute('style', `
              position: absolute;
              width: ${ width };
              height: ${ height };
              left: ${ x };
              top: ${ y };
              transform: translate(-${ x }, -${ y });
              z-index: 2;
          `);

          layer.innerHTML = `<img src="${ imgSrc }" alt="${ imgAlt }" style="float: unset;">`;
        }
      }

      function changeSponsorsRenderOutput(layer, width, height, x, y, imgSrc, imgAlt) {
        layer.setAttribute('style', `
            position: absolute;
            width: ${ width };
            height: ${ height };
            left: ${ x };
            top: ${ y };
            transform: translate(-${ x }, -${ y });
            z-index: 2;
        `);

        layer.innerHTML = `<img src="${ imgSrc }" alt="${ imgAlt }" style="float: unset;">`;
      }


      function changeNumberRenderOutput(layer, fontFamily, fontSize, fontColor, fontWeight, fontStyle, x, y, number) {
          layer.setAttribute('style', `
              position: absolute;
              font-family: ${ fontFamily };
              font-size: ${ fontSize };
              font-weight: ${ fontWeight };
              font-style: ${ fontStyle };
              color: ${ fontColor };
              left: ${ x };
              top: ${ y };
              transform: translate(-${ x }, -${ y });
              z-index: 3;
              white-space: nowrap;
          `);

        if (layer.getAttribute('predefined-svg-font') !== null) {
          layer.innerHTML = mapSvgInput(number, layer);
        } else {
          layer.innerHTML = number;
        }
      }

      function changeTextRenderOutput(layer, fontFamily, fontSize, fontColor, fontWeight, fontStyle, x, y, text) {
          layer.setAttribute('style', `
              position: absolute;
              font-family: ${ fontFamily };
              font-size: ${ fontSize };
              font-weight: ${ fontWeight };
              font-style: ${ fontStyle };
              color: ${ fontColor };
              left: ${ x };
              top: ${ y };
              transform: translate(-${ x }, -${ y });
              z-index: 4;
              white-space: nowrap;
          `);

        if (layer.getAttribute('predefined-svg-font') !== null) {
          layer.innerHTML = mapSvgInput(text, layer);
        } else {
          layer.innerHTML = text;
        }
      }
    
      function updateCustomizerProportions() {
          let maxHeight = 740;
          let maxTextFontSize = Number(document.querySelector('.product-personalise').dataset.textSize.replace('px', ''));
          let maxNumberFontSize = Number(document.querySelector('.product-personalise').dataset.numberSize.replace('px', ''));

          let customizerLayer = document.querySelector('#customizer-layer');
          let text = customizerLayer.querySelector('#customizer-text');
          let number = customizerLayer.querySelector('#customizer-number');

          let flktyHeight = flkty.viewport.getBoundingClientRect().height;
          let flktyHeightRatio = flktyHeight / maxHeight;
          let newTextFontSize = maxTextFontSize * flktyHeightRatio;
          let newNumberFontSize = maxNumberFontSize * flktyHeightRatio;

          text.style.fontSize = newTextFontSize + 'px';
          number.style.fontSize = newNumberFontSize + 'px';
      }

      function updateCustomizerReturnable() {
        let mandatoryFields = document.querySelectorAll('#form-badge-id, #form-sponsor-id, #form-name-id');
        let returnableField = document.querySelector('#form-returnable');

        if (mandatoryFields && returnableField) {
          let returnableFieldDisabled = true;
          mandatoryFields.forEach(e => {
            if (e.disabled == false) {
              returnableFieldDisabled = false;
            }
          })
          returnableField.disabled = returnableFieldDisabled;
        }
      }

      flkty.on('change', function() {
          if (flkty.selectedIndex !== selectedIndex)
              toggleCustomizerLayer(true);
          else
              toggleCustomizerLayer();
      });

      flkty.on('resize', function() {
          updateCustomizerProportions();
      });

      document.querySelector('#customizer-layer').addEventListener('click', function() {
          let flktyContainer = this.closest('flickity-carousel');

          if (flktyContainer) {
              if (flktyContainer.classList.contains('is-hovering-left'))
                  flkty.previous();
              else if (flktyContainer.classList.contains('is-hovering-right'))
                  flkty.next();
          }
      });
  }
});